import React from 'react'
import { H3 } from "@driftt/tide-core-legacy"
import './style.styl'

const SettingsPageHeader = ({ title }) =>
  <H3 className="settings-page-header">{title}</H3>

export default SettingsPageHeader



// WEBPACK FOOTER //
// ./src/scripts/components/settings/SettingsPageHeader/index.js